export const MobileAuth = () => {
  return <div>Авторизация...</div>;
};
